@let currentRoles = userRoles();

<div class="flex flex-col gap-2">
  @if (isLoading()) {
    <app-pan-blank-slate>
      <app-pan-spinner></app-pan-spinner>
      Loading branches & locations...
    </app-pan-blank-slate>
  } @else {
    <div>
      <app-pan-section-header title="System Roles" class="mb-2"></app-pan-section-header>

      <div class="flex gap-2">
        @for (role of possibleSystemRoles; track $index) {
          <app-pan-button
            [color]="currentRoles.system.includes(role.id) ? 'info' : 'default'"
            (click)="toggleSystemRole(role.id)"
            [disabled]="disabled()"
          >
            {{ role.name }}
          </app-pan-button>
        }
      </div>
    </div>

    <div>
      <app-pan-section-header title="Branch Roles" class="mb-2">
        @if (!disabled()) {
          <app-pan-button color="info" fill="outline" icon="add" action (click)="newBranch.show()"> </app-pan-button>
        }
      </app-pan-section-header>

      @if (!hasBranchRoles()) {
        No branch roles assigned.
      }

      @for (branch of branchesWithRoles(); track $index) {
        <div class="border-b border-gray-300 py-2 flex gap-2">
          <div class="flex-1 flex items-center max-w-[300px]" [matTooltip]="branch.name">
            {{ branch.name | truncate: 30 }}
          </div>

          <div class="flex-1 min-w-[200px]">
            <ng-select
              appendTo="body"
              placeholder="Select roles..."
              [bindValue]="'id'"
              [bindLabel]="'name'"
              [virtualScroll]="true"
              [items]="possibleBranchRoles"
              [(ngModel)]="currentRoles.branch[branch.id]"
              [multiple]="true"
              [clearable]="false"
              [disabled]="disabled()"
            >
            </ng-select>
          </div>

          @if (!disabled()) {
            <app-pan-button color="danger" icon="delete" (click)="removeBranch(branch)"></app-pan-button>
          }
        </div>
      }
    </div>

    <div>
      <app-pan-section-header title="Location Roles" class="mb-2">
        @if (!disabled()) {
          <app-pan-button color="info" fill="outline" icon="add" action (click)="newLocation.show()"> </app-pan-button>
        }
      </app-pan-section-header>

      @if (!hasLocationRoles()) {
        No location roles assigned.
      }

      @for (location of locationsWithRoles(); track $index) {
        <div class="border-b border-gray-300 py-2 flex gap-2">
          <div class="flex-1 flex items-center max-w-[300px]" [matTooltip]="location.name">
            {{ location.name | truncate: 30 }}
          </div>

          <div class="flex-1 min-w-[200px]">
            <ng-select
              appendTo="body"
              placeholder="Select roles..."
              [bindValue]="'id'"
              [bindLabel]="'name'"
              [virtualScroll]="true"
              [items]="possibleLocationRoles"
              [(ngModel)]="currentRoles.location[location.id]"
              [multiple]="true"
              [clearable]="false"
              [disabled]="disabled()"
            >
            </ng-select>
          </div>

          @if (!disabled()) {
            <app-pan-button color="danger" icon="delete" (click)="removeLocation(location)"></app-pan-button>
          }
        </div>
      }
    </div>
  }
</div>

<app-pan-modal #newBranch [topLevel]="false">
  <div header>Add Branch</div>

  <div body class="flex flex-col gap-2">
    <ng-select
      class="w-full"
      placeholder="Select branch..."
      [items]="allBranches()"
      [bindLabel]="'name'"
      [virtualScroll]="true"
      [clearable]="false"
      [(ngModel)]="branchToAdd"
      appendTo="body"
    >
    </ng-select>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>

    <app-pan-button panModalClose color="primary" (click)="addBranch(branchToAdd())" [disabled]="!branchToAdd()">
      Add Branch
    </app-pan-button>
  </div>
</app-pan-modal>

<app-pan-modal #newLocation [topLevel]="false">
  <div header>Add Location</div>

  <div body class="flex flex-col gap-2">
    <ng-select
      class="w-full"
      placeholder="Select location..."
      [items]="allLocations()"
      [bindLabel]="'name'"
      [virtualScroll]="true"
      [clearable]="false"
      [(ngModel)]="locationToAdd"
      appendTo="body"
    >
    </ng-select>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>

    <app-pan-button panModalClose color="primary" (click)="addLocation(locationToAdd())" [disabled]="!locationToAdd()">
      Add Location
    </app-pan-button>
  </div>
</app-pan-modal>
